import { observer } from "mobx-react";
import { observable, computed, action, autorun, toJS } from "mobx";
import { config } from "src/config";
import { authStore } from 'src/modules/auth';
import RichTextEditor from 'react-rte';

class SupportStore {
    @observable
    public tickets: any[];

    @observable
    public closedTickets: any[];

    @observable
    public currentTab: number = 0;

    @observable 
    public ticketSuccessDialogOpen: boolean = false;

    @observable
    public tickets_loaded: boolean = false;

    @observable
    public newNote: {
        content: any;
        attachments: any;
    } = {
        content: RichTextEditor.createEmptyValue(),
        attachments: []
    };

    @observable
    public newTicket: {
        subject: string;
        description: any;
        attachments: any;
    } = {
        subject: '',
        description: RichTextEditor.createEmptyValue(),
        attachments: []
    };

    @action
    public getMedportalTickets = async (auth_id: number) => {
        const response: Response = await fetch(
            config.BASE_URL + "/api/support/get_tickets/" + auth_id,
            {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: authStore.currentUser.SessionKey || "",
                },
                method: "GET",
            }
        );
        const responseJson = await response.json();

        this.tickets = responseJson.body.filter((ticket: any) => ticket.status !== 5);
        this.closedTickets = responseJson.body.filter((ticket: any) => ticket.status === 5);
        this.tickets_loaded = true;
    };

    @action 
    public submitTicket = async () => {
        const response: Response = await fetch(
            config.BASE_URL + "/api/support/submit_ticket",
            {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                method: "POST",
                body: JSON.stringify({ 
                    subject: this.newTicket.subject, 
                    description: this.newTicket.description.toString('html'),
                    attachments: this.newTicket.attachments,
                    auth_id: authStore.currentUser.auth_id
                })
            }
        );
        this.newTicket = {subject: '', description: RichTextEditor.createEmptyValue(), attachments: []};
        const responseJson = await response.json();
        this.tickets.unshift(responseJson.body);

        this.ticketSuccessDialogOpen = true;
        return setTimeout(() => this.getMedportalTickets(authStore.currentUser.auth_id), 60000);
    }

    @action 
    public submitNote = async (ticket_id: number) => {
        const response: Response = await fetch(
            config.BASE_URL + "/api/support/submit_note",
            {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                method: "POST",
                body: JSON.stringify({ 
                    content: this.newNote.content.toString('html'), 
                    attachments: this.newNote.attachments,
                    auth_id: authStore.currentUser.auth_id,
                    ticket_id
                })
            }
        );
        this.newNote = {content: RichTextEditor.createEmptyValue(), attachments: []};
        await this.getMedportalTickets(authStore.currentUser.auth_id);
    }
}

export default new SupportStore();


// WEBPACK FOOTER //
// ./src/modules/support/supportStore.ts